import { useSearchParams } from "react-router-dom";
import { useCallback, useMemo } from "react";

export const useSearchParam = (name: string) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchParam = useMemo(
    () => searchParams.get(name),
    [searchParams, name]
  );
  const setSearchParam = useCallback(
    (value: string | null) => {
      const newSearchParams = new URLSearchParams(searchParams);
      if (value) {
        newSearchParams.set(name, value);
        setSearchParams(newSearchParams);
      } else {
        newSearchParams.delete(name);
        setSearchParams(newSearchParams);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchParams, name]
  );
  return [searchParam, setSearchParam] as const;
};
